import GraphicSingleSelectQuestion from './GraphicSingleSelectQuestion';

export default GraphicSingleSelectQuestion;
